import React from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import { useTranslation } from './i18n';

interface ReferencePickerErrorProps {
  style?: React.CSSProperties;
  className?: string;
  onTryAgain?: () => void;
  children?: React.ReactNode;
}

const ReferencePickerError: React.FC<ReferencePickerErrorProps> = ({
  onTryAgain,
  className,
  style,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      padding="24px"
      style={style}
      className={className}
    >
      <AlertWarningIcon
        style={{
          color: theme.colors.charcoal700,
        }}
      />
      <Text
        typography="bodySmall"
        color="charcoal700"
        marginLeft="9px"
        marginRight="8px"
      >
        {children || t('ERROR_LOADING')}
      </Text>
      <LinkButton size={LinkButton.SIZES.SMALL} onClick={onTryAgain}>
        {t('TRY_AGAIN')}
      </LinkButton>
    </Flex>
  );
};

export default ReferencePickerError;
